__turbopack_context__.v({
  "card": "card-module-scss-module__wFgKGW__card",
  "card--clickable": "card-module-scss-module__wFgKGW__card--clickable",
  "card--elevation-0": "card-module-scss-module__wFgKGW__card--elevation-0",
  "card--elevation-1": "card-module-scss-module__wFgKGW__card--elevation-1",
  "card--elevation-2": "card-module-scss-module__wFgKGW__card--elevation-2",
  "card--no-radius": "card-module-scss-module__wFgKGW__card--no-radius",
  "card--secondary": "card-module-scss-module__wFgKGW__card--secondary",
  "card--small-radius": "card-module-scss-module__wFgKGW__card--small-radius",
});
